/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import { useNavigate } from "react-router-dom";
import Reveal from "./Reveal";

export default function FinalCTA({ isArabic }) {
  const navigate = useNavigate();

  return (
    <section className="gl-section" style={{ paddingTop: 0 }}>
      <div className="gl-shell">
        <Reveal>
          <div className="gl-cta-band">
            <h2 className="gl-title">
              {isArabic
                ? "جاهز لإطلاق متجرك في المدار؟"
                : "Ready to launch your store into orbit?"}
            </h2>
            <p className="gl-lead">
              {isArabic
                ? "انضم إلى آلاف التجار الذين يديرون مبيعاتهم عبر مدار المجرة."
                : "Join thousands of merchants running sales through Madar Galaxy."}
            </p>
            <div className="gl-cta-band__actions">
              <button
                type="button"
                className="gl-btn gl-btn--gold"
                onClick={() => navigate("/signup")}
              >
                {isArabic ? "أنشئ متجرك مجاناً" : "Create your store free"}
              </button>
              <button
                type="button"
                className="gl-btn gl-btn--ghost"
                onClick={() =>
                  document
                    .getElementById("plans-section")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
              >
                {isArabic ? "عرض الباقات" : "View plans"}
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
